<template>
  <div class=hydroware-container>
    <div class="col-xs-12 hydroware-container-heading">
      <table style=width:100%>
        <tr>
          <td style="text-align:left;">
            <slot name="header_title">
              <div style="font-size:2em;" v-if="title !== null">
                {{title}}
              </div>
            </slot>
          </td>
          <td style="text-align:right;">
            <slot name="after_header_title">
              <!--AFTER THE TITLE-->
            </slot>
          </td>
        </tr>
      </table>
    </div> <!--end of heading -->
    <div class="col-xs-12 hydroware-container-body">
      <!--The slot below is used for the body-->
      <slot name="body">
              <!--BODY-->
      </slot>
    </div> <!--end of body-->
  </div>
</template>
<script>
export default {
    props: ['title']
  }
</script> 


// WEBPACK FOOTER //
// hydroware-container-with-heading.vue?3f396d1d